import { TextManager } from "Components/TextContext";

export const setDocumentTitle = (title: string): void => {
  const { getText } = TextManager;
  document.title = `${title}${getText("documenttitle.separator")}${getText(
    "documenttitle.company",
  )}`;
};

export const setDocumentTitleForSubPage = (
  pageTitle: string,
  subPageTitle: string,
): void => {
  const { getText } = TextManager;
  setDocumentTitle(
    `${pageTitle}${getText("documenttitle.separator")}${subPageTitle}`,
  );
};
